<template>
  <div>
    <div class="card mb-2">
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex justify-content-between align-items-center font-weight-bold text-muted mb-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="ui.show = !ui.show"
          >
            Photos
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm"
            :disabled="$props.disabled || $props.value.length === 0"
            @click="removeAllRules"
          >
            Delete Rules
          </button>
        </h5>
        <div class="d-inline-flex">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="zoom"
          >
            Zoom {{ ui.columnWidth === 2 ? 'In' : 'Out' }}
          </button>
          <div class="dropdown">
            <button
              class="btn btn-primary btn-sm btn-sm dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="$props.disabled"
            >
              Mark All
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
            >
              <template v-for="rule in photoRulesIndividual.filter(r => r.forAll)">
                <button
                  type="button"
                  class="dropdown-item"
                  :key="rule.name"
                  @click="markAllAs(rule.name)"
                >
                  {{ rule.label }}
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <div
          class="alert alert-warning"
          v-if="error.show"
          v-html="error.msg"
        />
        <div v-if="$props.property.Photos && $props.property.Photos.length > 0">
          <div
            id="photo-scroller"
            class="form-row"
          >
            <template v-for="img in $props.property.Photos">
              <div
                :class="`col-${ui.columnWidth} photo-col mb-2 position-relative dropdown`"
                :key="img.Number"
              >
                <button
                  type="button"
                  class="btn d-block p-0 m-0 btn-img-options h-100 w-100"
                  data-toggle="dropdown"
                  :title="`Click for options (Image ${img.Number})`"
                  :disabled="$props.disabled"
                >
                  <div
                    class="photo-container card mb-0"
                    :style="`background-image: url(${cdnUrlWithSize(img.CdnUrl, 's640x480')})`"
                  />
                  <ul
                    class="markers list-unstyled m-0"
                    v-if="$props.value.some(r => r.imageURL && r.imageURL === img.CdnUrl)"
                  >
                    <template v-for="rule in photoRulesIndividual">
                      <li
                        v-show="$props.value.some(r => r.value === rule.name && r.imageURL && r.imageURL === img.CdnUrl)"
                        :class="rule.name"
                        :key="rule.name"
                        :title="rule.label"
                      />
                    </template>
                  </ul>
                </button>
                <div class="dropdown-menu">
                  <h6 class="dropdown-header px-2">
                    Mark As
                  </h6>
                  <template v-for="rule in photoRulesIndividual">
                    <button
                      type="button"
                      class="dropdown-item px-2"
                      @click="updateIndividual(img.CdnUrl, rule.name)"
                      :key="rule.name"
                      :disabled="$props.disabled"
                    >
                      <template v-if="$props.value.some(r => r.value === rule.name && r.imageURL && r.imageURL === img.CdnUrl)">
                        Remove {{ rule.label }}
                      </template>
                      <template v-else>
                        Add {{ rule.label }}
                      </template>
                    </button>
                  </template>
                  <div
                    role="separator"
                    class="dropdown-divider"
                  />
                  <button
                    @click="openImage(cdnUrlWithSize(img.CdnUrl, 's640x480'))"
                    class="dropdown-item px-2"
                    type="button"
                    :disabled="$props.disabled"
                  >
                    Open <i class="jam jam-chevron-square-up-right" />
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <p class="font-weight-bold">
              Mark Property With:
            </p>
            <ul class="in-cboxtags p-0 m-0">
              <template v-for="rule in photoRulesGrouped">
                <li :key="rule.name">
                  <input
                    type="checkbox"
                    :id="rule.name"
                    :name="rule.name"
                    :value="rule.name"
                    v-model="photos.groupIssueTags"
                    @input="updateGroup"
                    :disabled="$props.disabled"
                  >
                  <label :for="rule.name">{{ rule.label }}</label>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {
    photoRulesIndividual,
    photoRulesGrouped
} from '../common';

import { RuleScopeProperty } from '../consts';

import {
    makeImageRule,
    makeImageGroupRule,
    RuleKeyMarkAs
} from '../rules/image';

export default {
    data: () => ( {
        ui: {
            show: true,
            columnWidth: 2
        },
        error: {
            show: false,
            msg: ''
        },
        photoRulesIndividual: photoRulesIndividual,
        photoRulesGrouped: photoRulesGrouped,
        photos: {
            groupIssueTags: []
        }
    } ),
    methods: {
        removeAllRules() {
            this.$emit( 'input', [] );
        },
        validate() {
            let state = {
                valid: true,
                msg: ''
            };

            return state;
        },
        zoom() {
            if ( this.ui.columnWidth === 2 ) {
                this.ui.columnWidth = 6;
            } else {
                this.ui.columnWidth = 2;
            }
        },
        openImage( imageURL ) {
            const features = [
                'width=640',
                'height=480',
                'top=0',
                'left=0',
                'menubar=off',
                'toolbar=off',
                'location=off',
                'resizable=on',
                'scrollbars=off',
                'status=off'
            ];
            window.open( imageURL, 'TWC_ImagePreview`', features.join( ',' ) );
        },
        cdnUrlWithSize( url, size ) {
            const tokens = url.split( '/' );
            const k = tokens[ tokens.length - 1 ];
            const upd = tokens.splice( 0, tokens.length - 1 );
            upd.push( size, k );
            return upd.join( '/' );
        },
        reset() {
            this.ui = this.initialState;
            this.setGroupRules();
        },
        updateIndividual( imageURL, value ) {
            this.error.show = false;

            const result = makeImageRule( {
                imageURL: imageURL,
                key: RuleKeyMarkAs,
                value: value,
                createdBy: this.$store.getters.email,
                scope: RuleScopeProperty
            } );

            if ( result.error !== null ) {
                this.error.msg = result.error.toString();
                this.error.show = true;
                return;
            }

            const exists = this.$props.value.find( rule => rule.key === RuleKeyMarkAs && rule.imageURL === imageURL && rule.value === value );
            let rules = [];

            if ( exists ) {
                rules = this.$props.value.filter( rule => {
                    if ( rule.imageURL === imageURL && rule.key === RuleKeyMarkAs && rule.value === value ) {
                        return false;
                    }
                    return true;
                } );
                this.$emit( 'input', rules );
                return;
            }

            rules = this.$props.value;
            rules.push( result.rule );
            this.$emit( 'input', rules );
        },
        markAllAs( value ) {
            this.error.show = false;

            let rules = [];

            for ( let i = 0; i < this.$props.property.Photos.length; i++ ) {
                const imageURL = this.$props.property.Photos[ i ].CdnUrl;

                const result = makeImageRule( {
                    imageURL: imageURL,
                    key: RuleKeyMarkAs,
                    value: value,
                    createdBy: this.$store.getters.email,
                    scope: RuleScopeProperty
                } );

                if ( result.error !== null ) {
                    this.error.msg = result.error.toString();
                    this.error.show = true;
                    return;
                }

                const exists = this.$props.value.find( rule => rule.key === RuleKeyMarkAs && rule.imageURL === imageURL && rule.value === value );

                if ( exists ) {
                    continue;
                }

                rules.push( result.rule );
            }

            rules = [].concat( rules, this.$props.value );
            this.$emit( 'input', rules );
        },
        updateGroup( event ) {
            this.error.show = false;

            const checked = event.target.checked;
            const value = event.target.name;

            if ( checked ) {
                const result = makeImageGroupRule( {
                    key: RuleKeyMarkAs,
                    value: value,
                    createdBy: this.$store.getters.email,
                    scope: RuleScopeProperty
                } );

                if ( result.error !== null ) {
                    this.error.show = true;
                    this.error.msg = result.error.toString();
                    return;
                }

                this.addRule( result.rule );
                return;
            }

            let rules = this.$props.value;
            rules = rules.filter( rule => rule.value !== value );
            this.$emit( 'input', rules );
        },
        addRule( rule ) {
            let rules = this.$props.value;
            rules.push( rule );
            this.$emit( 'input', rules );
        },
        setGroupRules() {
            const groupRules = photoRulesGrouped.map( r => r.name );
            let grouped = [];
            this.$props.value.forEach( rule => {
                if ( rule.key === RuleKeyMarkAs && groupRules.includes( rule.value ) ) {
                    grouped.push( rule.value );
                }
            } );
            this.photos.groupIssueTags = grouped;
        }
    },
    watch: {
        value: {
            handler() {
                this.setGroupRules();
            }
        }
    },
    created() {
        this.initialState = this.ui;
        this.setGroupRules();
    },
    props: {
        property: {
            required: false,
            type: Object,
            default: () => ( {
                Photos: []
            } )
        },
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    }
};
</script>
<style scoped>
.photo-col:hover .photo-container {
  box-shadow: 0px 0px 0 2px #4382ce;
}

.photo-container {
  padding-top: 75%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  transition: all .2s ease;
}

.markers {
  position: absolute;
  bottom: 3px;
  left: 10px;
  background-color: #000;
  display: flex;
  width: 20px;
  justify-content: space-between;
  padding: 2px;
}

.markers li {
  width: 4px;
  height: 4px;
  z-index: 1;
}

.remove {
  background-color: red;
}

.watermark-major {
  background-color: orange;
}

.watermark-minor {
  background-color: yellow;
}

.duplicate {
  background-color: cyan;
}
</style>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/ImageRuleHandler.vue